"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("core.ui-module_site-components");
var _SecurityContextHolder = require("../../api/SecurityContextHolder");
var _RunAsController = _interopRequireDefault(require("../../api/auth/RunAsController"));
var _AuthComponentLoader = _interopRequireDefault(require("../../components/auth/AuthComponentLoader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _runAsController = /*#__PURE__*/new WeakMap();
class SwitchUser extends _react.default.Component {
  constructor(props) {
    super(props);
    _classPrivateFieldInitSpec(this, _runAsController, null);
    this.state = {
      authComponent: 'RunasUserSelectionStep',
      isShow: false
    };
    _classPrivateFieldSet(_runAsController, this, new _RunAsController.default(this));
    this.proceed = this.proceed.bind(this);
  }
  componentDidMount() {
    window.addEventListener('message', e => {
      try {
        if (e?.data?.runAsModal === false) {
          this.setState({
            isShow: false
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(`ERROR in post message listener ${error}`);
      }
    }, false);
  }
  toggleShow(isShow) {
    this.proceed(this);
    this.setState({
      isShow
    });
  }
  cancelModal() {
    this.setState({
      isShow: false
    });
  }
  proceed(stepListener, step) {
    if (step == null) {
      _classPrivateFieldGet(_runAsController, this).initialize(stepListener);
    } else {
      _classPrivateFieldGet(_runAsController, this).proceed(stepListener, step);
    }
  }
  render() {
    const {
      isShow,
      stepResponse,
      authComponent
    } = this.state;
    const content = (0, _AuthComponentLoader.default)(authComponent, this.proceed, stepResponse, this.props);
    if (isShow && !stepResponse) {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Modal, {
        showCloseIcon: false,
        header: "Please Wait.."
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "is-full-width has-text-centered"
      }, /*#__PURE__*/_react.default.createElement(_core.Spinner, null))));
    }
    if (isShow && stepResponse?.stepStatus !== 'FAILED') {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, content);
    }
    if (isShow && stepResponse?.stepStatus === 'FAILED') {
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.OkModal, {
        header: "Error",
        message: stepResponse?.message,
        display: stepResponse?.message !== '',
        key: stepResponse?.message,
        closeModalCallback: () => this.cancelModal()
      }));
    }
    return _SecurityContextHolder.SecurityContextHolder.isAuthenticated() && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("a", {
      onClick: () => {
        this.toggleShow(true);
      },
      className: "navbar-item contact-us px-3"
    }, "Switch User"));
  }
}
exports.default = SwitchUser;
SwitchUser.propTypes = {
  external: _propTypes.default.bool,
  cancelModal: _propTypes.default.any
};
SwitchUser.defaultProps = {
  external: undefined
};
//# sourceMappingURL=SwitchUser.js.map